var map = {
	"./BanList": 701,
	"./BanList.vue": 701,
	"./ChangeEmail": 532,
	"./ChangeEmail.vue": 532,
	"./ChangePassword": 8642,
	"./ChangePassword.vue": 8642,
	"./ChangePin": 9357,
	"./ChangePin.vue": 9357,
	"./Download": 2052,
	"./Download.vue": 2052,
	"./ForgetPassword": 1610,
	"./ForgetPassword.vue": 1610,
	"./GuildInfo": 4881,
	"./GuildInfo.vue": 4881,
	"./GuildRank": 5493,
	"./GuildRank.vue": 5493,
	"./Home": 6917,
	"./Home.vue": 6917,
	"./Page": 1843,
	"./Page.vue": 1843,
	"./PlayerInfo": 1817,
	"./PlayerInfo.vue": 1817,
	"./RankPlayer": 2743,
	"./RankPlayer.vue": 2743,
	"./Register": 9894,
	"./Register.vue": 9894,
	"./UserHome": 3408,
	"./UserHome.vue": 3408,
	"./VerifyEmail": 1845,
	"./VerifyEmail.vue": 1845,
	"./Vote4Coins": 7822,
	"./Vote4Coins.vue": 7822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;